export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7643.e4b10e28.jpg";